<script lang="ts">
  import DailyGame from './DailyGame.svelte';
  import GameContext from '~/store/GameContext.svelte';
  import DailyRulesModal from '~/tutorial/daily/DailyRulesModal.svelte';
  import DailyOnboarding from '~/tutorial/daily/DailyOnboarding.svelte';
  import {
    getPuzzleKeyFromURL,
    puzzleQuery,
    isPremium,
  } from '~/lib/queries.svelte';
  import { page } from '$app/state';
  import { dims } from '~/utils/dimensions.svelte';
  import PuzzleSummary from '~/calendar/PuzzleSummary.svelte';
  import Loading from '~/components/Loading.svelte';
  import { DailyGame as Daily } from '~/store/daily.svelte';
  import DimensionsContext from '~/utils/DimensionsContext.svelte';
  import type { DailyPuzzle } from '~/types';
  import { premiumModal } from '~/modals/PremiumModal.svelte';
  import { hydrated, onboarded, tutorialViewed } from '~/tutorial/state.svelte';

  // TODO only consider date and key
  const puzzleKey = $derived(getPuzzleKeyFromURL(page));
  const puzzle = $derived(puzzleQuery<DailyPuzzle>(puzzleKey));
  let firstLoad = $state<Promise<Daily>>();
  let prevKey = $state('');
  // only reload when changing route
  $effect(() => {
    if (puzzleKey !== prevKey && puzzle.data) {
      prevKey = puzzleKey;
      firstLoad = Daily.load(puzzle.data, page.url.search.length === 0);
    }
  });

  const premium = isPremium();

  // if non-premium user is accessing puzzle by date, show premium modal
  $effect(() => {
    const date = page.url.searchParams.get('date');
    if (!date || date === 'latest') return;

    if (!page.data.user || (premium.isFetched && !premium.data)) {
      premiumModal.push('archive');
    }
  });
</script>

<DimensionsContext {dims}>
    {#if !hydrated.current}
      <Loading />
    {:else if !onboarded.current}
      <DailyOnboarding />
    {:else}
      {#await firstLoad}
        <Loading />
      {:then game}
        {#if game}
          <GameContext {game}>
            <DailyGame />
          </GameContext>
        {/if}
      {:catch err}
        Error: {err}
      {/await}
    {/if}
  <DailyRulesModal />
  <PuzzleSummary />
</DimensionsContext>
